/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Prolabel1Inputs */

const zh_plan_prolabel1 = /** @type {(inputs: Plan_Prolabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const en_plan_prolabel1 = /** @type {(inputs: Plan_Prolabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const es_plan_prolabel1 = /** @type {(inputs: Plan_Prolabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Plan_Prolabel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_prolabel1 = /** @type {((inputs?: Plan_Prolabel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Prolabel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_prolabel1(inputs)
	if (locale === "en") return en_plan_prolabel1(inputs)
	return es_plan_prolabel1(inputs)
});
export { plan_prolabel1 as "plan_proLabel" }